import { $, ps } from '../util/view';
import { cast as castArray } from '../util/array';
import modal from './modal';
import tabs from './tabs';
import confirmation from './confirmation';
import { postTrackingEvent } from '../util/tracking';
import CCPALAyer3Message from './layer3Message';
const accordion = (title, content) => {
    const children = [
        $('div', { class: 'mol-ads-cmp-accordion-title' }, [
            $('div', { class: 'mol-ads-cmp-accordion-title-container' }, [title]),
            $('div', { class: 'mol-ads-cmp-accordion-chevron' }, '❮'),
        ]),
        $('div', { class: 'mol-ads-cmp-accordion-panel' }, content),
    ];
    return $('div', { class: 'mol-ads-cmp-accordion' }, children).click((e) => {
        const target = e.currentTarget;
        if (target) {
            const classNames = target.className.split(' ');
            if (classNames.find((el) => el === 'active'))
                classNames.pop();
            else
                classNames.push('active');
            target.className = classNames.join(' ');
            const panel = target.querySelector('.mol-ads-cmp-accordion-panel');
            panel.style.maxHeight = panel.scrollHeight + 'px';
        }
    });
};
const byName = (a, b) => a.name.localeCompare(b.name);
const renderAdvertisers = (vendorList) => {
    const { vendors, purposes, features } = vendorList;
    return $('ul', { class: 'mol-ads-cmp--settings-consents' }, [...vendors].sort(byName).map((vendor) => $('li', { class: 'mol-ads-cmp--settings-consent' }, [
        accordion($('div', { class: 'mol-ads-cmp-accordion-title-content' }, [
            $('div', { class: 'mol-ads-cmp--settings-consent-name' }, vendor.name),
            $('a', {
                class: 'mol-ads-cmp--settings-consent-policy',
                href: vendor.policyUrl,
                target: '_blank',
            }, 'Privacy policy'),
        ]), [
            $('div', {}, Object.keys(vendor)
                .filter((key) => {
                const include = [
                    'purposeIds',
                    'legIntPurposeIds',
                    'featureIds',
                ];
                if (include.find((el) => el === key && vendor[key].length > 0))
                    return true;
                return false;
            })
                .map((key) => {
                const details = {
                    purposeIds: {
                        title: 'Relying on Consent for:',
                        data: purposes,
                    },
                    legIntPurposeIds: {
                        title: 'Relying on Legitimate Interest for:',
                        data: purposes,
                    },
                    featureIds: {
                        title: 'Features:',
                        data: features,
                    },
                };
                return $('div', { class: 'mol-ads-cmp-list' }, [
                    $('div', { class: 'mol-ads-cmp-list-header' }, details[key].title),
                    $('ul', {}, vendor[key].map((id) => $('li', {}, `- ${details[key].data.find((el) => el.id === id)
                        .name}`))),
                ]);
            })),
        ]),
    ])));
};
export default function render({ onAccept, onCloseSettings, onDecline, nonTCFRegisteredVendors, nonRegisteredVendors, hasTPhrase, translate, vendorList, renderConfig, }) {
    let selectedTab = 'functional';
    const settingTabs = tabs({
        items: [
            {
                body: $('div', {}, [
                    $('div', { class: 'mol-ads-cmp--settings-purposes-title' }, 'Purposes'),
                    $('br'),
                    translate('settings.advertising.purposes.description_1'),
                    $('a', {
                        href: renderConfig.layerTwo.ccpaFrameworkHref ||
                            'https://www.iab.com/guidelines/ccpa-framework/',
                        target: '_blank',
                    }, `The ${renderConfig.layerTwo.ccpaFrameworkText}`),
                    ' and complies with its specifications and policies.',
                    $('br'),
                    $('br'),
                    translate('We work with advertising partners to show content and advertisement for products and services you might like. Understand how your data may be used and who our partners are below:'),
                    $('ul', { class: 'mol-ads-cmp--settings-consents' }, vendorList.purposes.map(({ id, name, description }, i) => $('li', { class: 'mol-ads-cmp--settings-consent' }, [
                        accordion($('div', { class: 'mol-ads-cmp-accordion-title-content' }, [
                            $('div', { class: 'mol-ads-cmp--settings-consent-bullet' }, [
                                $('div', { class: 'mol-ads-cmp-circle' }, `${i + 1}`),
                                $('div', {}, name),
                            ]),
                        ]), $('div', {}, [
                            $('div', {}, description),
                            $('br'),
                            $('div', {}, 'Vendors that use data in this way:'),
                            $('br'),
                            $('div', { class: 'mol-ads-policy-link-list' }, vendorList.vendors
                                .filter((vendor) => vendor.purposeIds.find((el) => el === id))
                                .map(({ name, policyUrl }) => $('a', { href: policyUrl, target: '_blank' }, name))),
                        ])),
                    ]))),
                    $('h3', {}, translate('settings.advertising.purposes.descriptionExtraH5')),
                    ...ps(translate('settings.advertising.purposes.descriptionExtraP5')),
                    $('ul', { class: 'mol-ads-cmp--settings-consents' }, vendorList.features.map(({ id, name }, i) => $('li', { class: 'mol-ads-cmp--settings-consent' }, [
                        accordion($('div', { class: 'mol-ads-cmp-accordion-title-content' }, [
                            $('div', { class: 'mol-ads-cmp--settings-consent-name' }, [
                                'A. Offline Data Matching',
                                'B. Device linking',
                                'C. Precise geographic location data',
                            ][i]),
                        ]), $('div', {}, [
                            $('div', {}, translate(`settings.advertising.purposes.descriptionExtraP${i + 6}`)),
                            $('br'),
                            $('div', {}, 'Vendors that use data in this way:'),
                            $('br'),
                            $('div', { class: 'mol-ads-policy-link-list' }, vendorList.vendors
                                .filter((vendor) => vendor.featureIds.find((el) => el === id))
                                .map(({ name, policyUrl }) => $('a', { href: policyUrl, target: '_blank' }, name))),
                        ])),
                    ]))),
                ]),
                onSelect: () => {
                    selectedTab = 'advertising';
                    postTrackingEvent('settings advertising tab clicked');
                },
                title: 'Purposes',
            },
            {
                body: $('div', {}, [
                    $('strong', { class: 'mol-ads-vendorlist-title' }, 'Associated Newspapers Ltd.'),
                    renderAdvertisers({
                        purposes: vendorList.purposes,
                        features: vendorList.features,
                        vendors: [
                            {
                                id: 2,
                                name: 'Associated Newspapers Ltd. (MailOnline, ThisIsMoney & Metro)',
                                policyUrl: '/privacy',
                                purposeIds: [1, 2, 3, 4],
                                legIntPurposeIds: [5],
                                featureIds: [1],
                            },
                        ],
                    }),
                    $('strong', { class: 'mol-ads-vendorlist-title' }, 'TCF-Registered Vendors'),
                    $('p', { class: 'mol-ads-vendors-paragraph' }, [
                        'Below is a list of the third-party advertising companies who may have access to this data for the purposes and features they each declare when you click ',
                        $('strong', {}, '"Got It" '),
                        'or ',
                        $('strong', {}, '"Allow All".'),
                    ]),
                    renderAdvertisers(vendorList),
                    $('strong', { class: 'mol-ads-vendorlist-title' }, 'Non-TCF Registered Vendors'),
                    $('ul', { class: 'mol-ads-non-registered-vendors' }, nonTCFRegisteredVendors
                        .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase()
                        ? -1
                        : a.name.toLowerCase() > b.name.toLowerCase()
                            ? 1
                            : 0)
                        .map((vendor) => $('li', {}, [
                        $('div', { class: 'mol-ads-non-registered-item' }, [
                            $('div', {}, vendor.name),
                            $('a', { href: vendor.policyUrl, target: '_blank' }, 'Privacy policy'),
                        ]),
                    ]))),
                    $('strong', { class: 'mol-ads-vendorlist-title' }, 'Non–Registered Vendors'),
                    $('ul', { class: 'mol-ads-non-registered-vendors' }, nonRegisteredVendors
                        .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase()
                        ? -1
                        : a.name.toLowerCase() > b.name.toLowerCase()
                            ? 1
                            : 0)
                        .map((vendor) => $('li', {}, [
                        $('div', { class: 'mol-ads-non-registered-item' }, [
                            $('div', {}, vendor.name),
                            $('a', { href: vendor.policyUrl, target: '_blank' }, 'Privacy policy'),
                        ]),
                    ]))),
                ]),
                onSelect: () => {
                    selectedTab = 'functional';
                    postTrackingEvent('settings functional tab clicked');
                },
                title: 'Vendors',
            },
        ],
        onSwitch: () => {
            // settings.raw.classList.toggle('mol-ads-cmp--settings-functional')
            // settings.raw.classList.toggle('mol-ads-cmp--settings-advertising')
        },
    });
    const confirm = () => {
        const close = () => {
            view.close();
        };
        const view = confirmation({
            confirmText: translate('settings.confirmation.confirm'),
            declineText: translate('settings.confirmation.decline'),
            footer: undefined,
            message: CCPALAyer3Message({ hasTPhrase, renderConfig, translate }),
            onConfirm: [
                close,
                () => postTrackingEvent('settings advertising panel disallow declined'),
                ...castArray(onAccept),
                ...castArray(onCloseSettings),
            ],
            onDecline: [
                close,
                () => postTrackingEvent('settings advertising panel disallow confirmed'),
                ...castArray(onDecline),
                ...castArray(onCloseSettings),
            ],
            title: translate('settings.confirmation.title'),
        });
        settings.appendChild(view);
    };
    const settingsModal = modal({
        body: settingTabs,
        footer: [
            $('a', { class: 'mol-ads-cmp-footer-privacy' }, hasTPhrase('settings.footer.privacy')
                ? translate('settings.footer.privacy')
                : renderConfig.layerTwo.footerPrivacyText)
                .click(confirm)
                // FIXME if confirm denied then postTrackingEvent
                .click(() => postTrackingEvent('settings advertising panel disallow')),
            $('div', { class: 'mol-ads-cmp-footer-buttons' }, [
                $('button', { class: 'mol-ads-cmp--btn-primary', type: 'button' }, 'Allow all')
                    .click(() => postTrackingEvent(`settings ${selectedTab} panel allow all`))
                    .click(onAccept)
                    .click(onCloseSettings),
            ]),
        ],
        title: translate('settings.title'),
    });
    const settings = $('div', { class: 'mol-ads-cmp--settings mol-ads-cmp--settings-advertising' }, settingsModal);
    return settings;
}
